import { useSharedContext } from "./shared-context";
import { fhirSections } from "../shared-components/fhir-sections/sections";
import { useMemo } from "react";

export const useFhirSections = () => {
  const { sharedState } = useSharedContext();
  const isShowDummySections = sharedState.isMetriportUser;
  const isAmazonUser = sharedState.isAmazonUser;
  const isTeladocUser = sharedState.isTeladocUser;

  const filteredFhirSections = useMemo(() => {
    const dummySections = ["caregaps"];
    const amazonOnlySections = ["suspects"];

    return fhirSections.filter(section => {
      // Filter out dummy sections for non-Metriport users and non-Teladoc users
      if (dummySections.includes(section.key) && !isShowDummySections && !isTeladocUser) {
        return false;
      }

      // Filter out Amazon-only sections for non-Amazon users and non-Teladoc users
      if (amazonOnlySections.includes(section.key) && !isAmazonUser && !isTeladocUser) {
        return false;
      }

      return true;
    });
  }, [fhirSections, isShowDummySections, isAmazonUser, isTeladocUser]);

  return { filteredFhirSections };
};
